
import { mapGetters } from 'vuex';
import UICreatePost from '@/components/ui/organism/UICreatePost';
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
import CustomModal from '~/components/ui/molecule/CustomModal.vue';
import PostLeagueCard from '../molecule/PostLeagueCard.vue';

export default {
  name: 'UICreatePostModal',
  components: { UICreatePost, CloseIcon, CustomModal, PostLeagueCard },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    profileImg: {
      type: String,
      required: true,
    },
    profileName: {
      type: String,
      required: true,
    },
    clear: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    uploadImage: {
      type: Function,
      required: true,
    },
    searchMentions: {
      type: Function,
      required: true,
    },
    searchHashtags: {
      type: Function,
      required: true,
    },
    targetType: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'create_post',
    },
    mentionedPost: {
      type: Object,
      default: () => null,
    },
    originalPost: {
      type: Object,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    portfolio: {
      type: Object,
      default: () => null,
    },
    transactionData: {
      type: Object,
      default: () => null,
      required: false,
    },
    isEmailConfirmed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitPost: false,
      postButtonState: true,
      isPostEmpty: true,
    };
  },
  computed: {
    ...mapGetters('modals', ['showCreatePostModalRes']),
    league() {
      return this.showCreatePostModalRes.league;
    },
  },
  watch: {
    show() {
      if (this.show) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    },
  },
  methods: {
    propagateSubmitPost() {
      this.submitPost = true;
    },
    handlePostEmptyChange(val) {
      this.isPostEmpty = val;
    },
    updatePostButtonState(state) {
      this.postButtonState = state;
    },
    resetPostButtonState() {
      this.postButtonState = true;
    },
  },
};
